import React, { Component } from 'react'
import { connect } from 'react-redux'
import compose from 'lodash/fp/compose'
import find from 'lodash/find'
import isEmpty from 'lodash/isEmpty'
import prepareComponent from 'client/shared/decorators/prepare-component'

import { load as loadBook } from 'client/bookmate/reducers/book-reducer'
import { load as loadAudiobook } from 'client/bookmate/reducers/audiobook-reducer'
import { load as loadComicbook } from 'client/bookmate/reducers/comicbook-reducer'
import SVGInline from 'react-svg-inline'
import Leaf from 'client/shared/icons/leaf.svg'
import LeafOrange from 'client/shared/icons/leaf-orange.svg'
import Boom from 'client/shared/icons/boom.svg'
import Blot from 'client/shared/icons/weird-blot-2.svg'
import { Gifts as GiftsIndex } from 'client/bookmate/blocks/gifts'
import { CurrentUserState } from 'client/shared/types/current-user'
import { GiftPlan } from '../reducers/gifts-reducer'
import uiBox, { DecoratorProps } from 'client/shared/decorators/ui-box'
import { Locale } from 'client/shared/types/current-user'
import { State } from 'shared/types/redux'

type Props = {
  kind: string
  currentUser: CurrentUserState
  audioPlans?: string[]
  locale: Locale
  plans: GiftPlan[]
  currentPlanId: string
  userCountry: string
} & DecoratorProps

class GiftsIndexBox extends Component<Props> {
  render() {
    const {
      kind,
      currentUser: {
        data: { comics },
      },
      audioPlans,
      plans,
      currentPlanId,
      locale,
      userCountry,
    } = this.props

    const currentPlan = find(plans, plan => plan.id === currentPlanId)

    return (
      <>
        <SVGInline svg={Leaf} className="decor__icon leaf" />
        <SVGInline svg={LeafOrange} className="decor__icon leaf-orange" />
        <SVGInline svg={Boom} className="decor__icon boom" />
        <SVGInline svg={Blot} className="decor__icon blot" />
        <GiftsIndex
          isAudioAvailable={Boolean(audioPlans?.length)}
          areComicsAvailable={comics}
          kind={kind}
          locale={locale}
          userCountry={userCountry}
          plans={plans}
          currentPlan={currentPlan}
        />
      </>
    )
  }
}

export const TRANSLATIONS = [
  {
    heading: 'gifts_faq_heading_subscription',
    content: 'gifts_faq_content_subscription',
  },
  { heading: 'gifts_faq_heading_how_to', content: 'gifts_faq_content_how_to' },
  {
    heading: 'gifts_faq_heading_duration',
    content: 'gifts_faq_content_duration',
  },
]

const prepareComponentWrapper = prepareComponent(async function ({ store }) {
  const { dispatch } = store
  const {
    card: { suggestedItemId, suggestedItemType },
  } = store.getState().gifts

  if (suggestedItemId) {
    switch (suggestedItemType) {
      case 'book':
        await dispatch(loadBook(suggestedItemId))
        break

      case 'audiobook':
        await dispatch(loadAudiobook(suggestedItemId))
        break

      case 'comicbook':
        await dispatch(loadComicbook(suggestedItemId))
        break
    }
  }
})

const wrapper = compose(
  uiBox,
  prepareComponentWrapper,
  connect((state: State) => {
    const { audio } = state.gifts.kinds
    const { kind, kinds } = state.gifts

    const commonProps = {
      currentUser: state.currentUser,
      kind: state.gifts.kind,
      audioPlans: audio ? audio.plans : [],
      locale: state.currentUser.data.locale,
      userCountry: state.currentUser.data.country,
    }

    if (!isEmpty(kinds)) {
      const {
        [kind]: { plans, planId },
      } = kinds

      return {
        ...commonProps,
        plans,
        currentPlanId: planId,
      }
    } else {
      return {
        ...commonProps,
        plans: [],
        currentPlanId: '',
      }
    }
  }),
)

export default wrapper(GiftsIndexBox)
